export function getApiKey(): string {
  const API_KEY = process.env.GOOGLE_PLACES_API_KEY
  return API_KEY ? API_KEY : 'AIzaSyAcDR2iIG5f6C4_525_sSyqYNHvyJAYdAM'
}
